import { Spoiler, Text, rem } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { DeploymentStatus } from '@/types/deployment'

type DeploymentErrorSpoilerProps = {
  status: DeploymentStatus
  errorBody: string
}

export const DeploymentErrorSpoiler = ({
  status,
  errorBody
}: DeploymentErrorSpoilerProps) => {
  const showsError =
    status === DeploymentStatus.Failed || status === DeploymentStatus.Recovering

  if (!showsError || !errorBody) {
    return null
  }

  return (
    <Spoiler
      maxHeight={48}
      showLabel={<FormattedMessage id="showMore" />}
      hideLabel={<FormattedMessage id="showLess" />}
      mt="xs"
      styles={{
        control: {
          fontSize: rem(12)
        }
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Text size="xs" c={status === DeploymentStatus.Failed ? 'red' : 'orange'}>
        {errorBody}
      </Text>
    </Spoiler>
  )
}
